<!--添加商品  -->
<template>   
<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" 
        :before-close="handleClose" append-to-body>
    <el-form :model="ruleForm" :rules="rules" ref="formRef" label-width="100px">                
        <el-row>
            <el-col :span="12">
                <el-form-item label="商品标题" prop="productName">  
                    <el-input v-model="ruleForm.productName" placeholder="请输入商品标题" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="副标题" prop="subName">  
                    <el-input v-model="ruleForm.subName" placeholder="请输入商品副标题" ></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="商品类别" prop="category">
                    <el-select v-model="ruleForm.category" style="width: 100%;">
                        <el-option 
                            v-for="item in typeOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="商品描述" prop="des">
                    <el-input v-model="ruleForm.des" placeholder="请输入商品描述" ></el-input>
                </el-form-item>
            </el-col>            
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="商品邮费" prop="postage">
                    <el-input type="text" v-model="ruleForm.postage" maxlength="5"
                        placeholder="请输入商品邮费">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="是否置顶" prop="isDefault">
                    <el-radio-group v-model="ruleForm.isDefault">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>                
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="发货规则" prop="deliverRules">  
                    <el-select v-model="ruleForm.deliverRules" style="width: 100%;">
                        <el-option 
                            v-for="item in deliverOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="退货规则" prop="refundRules">  
                    <el-select v-model="ruleForm.refundRules" style="width: 100%;">
                        <el-option 
                            v-for="item in refundOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                        </el-select>
                </el-form-item>
            </el-col>
        </el-row>         
        <el-row>               
            <el-col>
                <el-form-item label="商品主图" prop="mainImageUrl" class="form" >
                    <el-upload class="avatar-uploader" ref="coverPicUpload" action="" 
                            list-type="picture-card" accept="image/*" multiple :limit="9" name="file"
                            :file-list="fileList"                             
                            :http-request="handleRequest"
                            :on-change="handleFileChange" 
                            :before-upload="handleBeforeUpload" 
                            :on-error="handleUploadError"
                            :on-exceed="handleExceed"
                            :on-remove="handleRemove">
                            <i class="el-icon-plus" />
                    </el-upload>
                </el-form-item>   
            </el-col>   
        </el-row>
        <el-row>            
            <el-form-item label="图文详情" prop="imageTextUrl">
                <el-upload class="avatar-uploader" ref="coverPicUpload2" action="" 
                list-type="picture-card" accept="image/*"
                        multiple :limit="9" name="file" 
                        :file-list="fileList2"
                        :on-change="handleFileChange2" 
                        :http-request="handleRequest2" 
                        :before-upload="handleBeforeUpload" 
                        :on-error="handleUploadError"
                        :on-exceed="handleExceed"
                        :on-remove="handleRemove2">
                        <i class="el-icon-plus" />
                    </el-upload>
            </el-form-item>                     
        </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="confirmDialog">确定</el-button>
        </span>

</el-dialog>

</template>    
<script>
export default {
    props:{       
        title:{
            type: String,
            default: ''
        },
        formData: {
            type: Object,
            default:{}
        },
    },
    components:{
        
    },
    data() {
        return {
            dialogTitle: '',            
            ruleForm: {
                productName: '',
                index: '',
                subName: '',
                category: '',
                des: '',
                postage: 0,
                isDefault: 0,
                deliverRules: '',
                refundRules: '',
                mainImageUrl: '',
                imageTextUrl: '',               
            },
            rules: {
                productName:[
                    { required: true, message: '请输入商品标题', trigger: 'blur' },
                ],                               
                category: [
                    { required: true, message: '请选择商品类别', trigger: 'change' },
                ],              
            },
            disabled: false,
            editUsername: false,
            typeOption: [],
            deliverOption: [],
            refundOption: [],             
            dialogVisible: true,   
            fileList: [],   
            fileList2: [],   
            filesToUpload: [],
            uploadIndex: 0, 
            uploadedLinksMain: [],
            uploadedLinksText: [],
            uploadedFiles: new Set(), // 记录已上传的文件名（避免重复）   
        }
    },
    created() {
        this.dialogTitle = this.title        
        if(this.dialogTitle === '更新商品'){
            this.ruleForm = {...this.formData}
            // console.log(this.ruleForm)
            if(this.ruleForm.mainImageUrl !== '' && this.ruleForm.mainImageUrl.indexOf(',') !== -1){
                let imageNames = this.ruleForm.mainImageUrl.split(',')
                
                const imageObjects = imageNames.map((name,index) =>{
                    return {
                        id: index,
                        name: name,
                        url: this.$global.uploadUrl + name
                    }
                })
                this.fileList = imageObjects
                this.uploadedLinksMain = imageObjects
            }else{
                if(this.ruleForm.mainImageUrl !== ''){
                    let imageObjects = [{
                        id: 0,                        
                        name: this.ruleForm.mainImageUrl,
                        url: this.$global.uploadUrl + this.ruleForm.mainImageUrl,
                    }]
                    this.fileList = imageObjects
                    this.uploadedLinksMain = imageObjects
                }
            }
            if(this.ruleForm.imageTextUrl !== ''  && this.ruleForm.imageTextUrl.indexOf(',') !== -1){
                let imageNames = this.ruleForm.imageTextUrl.split(',')
                
                const imageObjects = imageNames.map((name,index) =>{
                    return {
                        id: index,
                        name: name,
                        url: this.$global.uploadUrl  + name
                    }
                })
                this.fileList2 = imageObjects
                this.uploadedLinksText = imageObjects
            }else{
                if(this.ruleForm.imageTextUrl !== ''){
                    let imageObjects = [{
                        url: this.$global.uploadUrl + this.ruleForm.imageTextUrl,
                        name: this.ruleForm.imageTextUrl,
                        id: 1
                    }]
                    this.fileList2 = imageObjects
                    this.uploadedLinksText = imageObjects
                }
            }
        }  
    },
    mounted() {       
        this.getType()
        this.getDeliverRules()
        this.getRefundRules()
    },
    methods: {
        getType(){            
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 110,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.typeOption = arr.map(item=>{
                        return{
                            label: item['中文描述'],
                            value: item['词条索引']
                        }
                    })                   
                }
            })
        }, 
        getDeliverRules(){            
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 111,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.deliverOption = arr.map(item=>{
                        return{
                            label: item['中文描述'],
                            value: item['词条索引']
                        }
                    })                   
                }
            })
        },      
        getRefundRules(){            
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 114,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.refundOption = arr.map(item=>{
                        return{
                            label: item['中文描述'],
                            value: item['词条索引']
                        }
                    })                    
                }
            })
        },       
        confirmDialog() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    // 校验通过，传递表单数据到父组件
                    this.handleSubmit()    
                } else {
                    window.scrollTo({
                        top:0,
                        behavior: 'smooth'
                    })
                    console.log('表单校验失败');
                    return false;
                }
            });
        }, 
        handleSubmit(){
            let { productName,subName,category,postage,isDefault, deliverRules,refundRules,
                des,mainImageUrl,imageTextUrl} = this.ruleForm       
            let opcode =  this.dialogTitle === '更新商品' ? this.$code.UpdateShelf :   this.$code.ADDGoods   
            let params = {}
            let addParams = {
                opcode: opcode,
                v_goods_title: productName,
                v_goods_subtitle: subName,
                v_goods_classify: category,                
                v_details: des, //商品详情
                v_images: mainImageUrl, //封面主图,用作详情轮播图
                v_images_details: imageTextUrl,//商品图文详情
                v_goods_summary: '', //商品备注
                c_topup: isDefault,
                v_Free_Shipping: postage,
                v_Shipping_Rules: deliverRules,               
                v_Return_policy: refundRules
            }
            let updateParams = {
                v_goods_serial: this.ruleForm.productId,
                c_status: this.ruleForm.statusValue,
            }          
            if(this.dialogTitle === '更新商品'){
                params =  Object.assign({}, addParams, updateParams)
            }else{
                params = addParams
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.disabled = true
                    if(this.dialogTitle==='更新商品'){
                        this.$message.success('更新商品成功')
                    }else{
                        this.$message.success('设置商品成功')
                    }    
                    this.$emit('confirm');
                    this.closeDialog();        
                }else{
                    this.$message.error(res.Message)
                }
            })
        },   
        // 文件选择变化时的回调
        handleFileChange(file, fileList) {
            // 手动校验文件数量
            if (fileList.length > 9) {
                this.$message.warning('最多只能上传9张图片');
                // 移除超出限制的文件（可选）
                fileList.pop(); // 保留最后选择的9个文件
                this.fileList = fileList.slice(0, 9);
                return;
            }
            this.fileList = fileList; // 更新文件列表     
           
        }, 
        // 文件选择变化时的回调
        handleFileChange2(file, fileList) {
            // 手动校验文件数量
            if (fileList.length > 9) {
                this.$message.warning('最多只能上传9张图片');
                // 移除超出限制的文件（可选）
                fileList.pop(); // 保留最后选择的9个文件
                this.fileList2 = fileList.slice(0, 9);
                return;
            }
            this.fileList2 = fileList; // 更新文件列表         
        }, 
        async handleRequest(file, fileList){ 
            try{
                const imageUrl = await this.$help.uploadMoreFileRequest(file)

                if(imageUrl){
                    this.uploadedLinksMain.push(
                        {
                            name: imageUrl,
                            url: imageUrl
                        }
                    );
                this.ruleForm.mainImageUrl  =  this.uploadedLinksMain.map(file => file.name).join(',')   
                }  
                // console.log(this.fileList)
                this.$message.success('上传图片成功');
            }catch (error) {
                console.error('上传失败:', error);
                this.$message.error('上传失败，请重试');
            }
            // console.log('商品主图',this.uploadedLinksMain)
            // this.$refs.coverPicUpload.clearFiles()
        },
        async handleRequest2(file,fileList){
            try{
                const imageUrl = await this.$help.uploadMoreFileRequest(file)

                if(imageUrl){
                    this.uploadedLinksText.push(
                        {
                            name: imageUrl,
                            url: imageUrl
                        }
                    );
                    this.ruleForm.imageTextUrl = this.uploadedLinksText.map(file => file.name).join(',')
                }  
                this.$message.success('上传图片成功');
            }catch (error) {
                console.error('上传失败:', error);
                this.$message.error('上传失败，请重试');
            }
            // console.log('商品详情图',this.uploadedLinksText)

            // this.$refs.coverPicUpload2.clearFiles()
        },
        handleRemove(file, fileList) {
            console.log(file.name)
            this.fileList = fileList;
            this.uploadedLinksMain = fileList
            this.ruleForm.mainImageUrl =  this.uploadedLinksMain.map(file => file.name).join(',')
        },
        handleRemove2(file, fileList) {
            // console.log(file,fileList)
            this.fileList2 = fileList;
            this.uploadedLinksText = fileList
            this.ruleForm.imageTextUrl =  this.uploadedLinksText.map(file => file.name).join(',')

            // 从已上传链接中移除对应的链接（如果存在）
            // if(this.dialogTitle === '更新商品'){
            //     const index = this.uploadedLinksText.findIndex(
            //     item => item.name === file.name
            // );
            // if (index !== -1) {
            //     this.uploadedLinksText.splice(index, 1);
            //     this.ruleForm.imageTextUrl =  this.uploadedLinksText.map(file => file.name).join(',') 
            // }
            // }else{
            //     const index = this.uploadedLinksText.findIndex(
            //     item => item.name === file.raw.name
            // );
            // if (index !== -1) {
            //     this.uploadedLinksText.splice(index, 1);
            //     this.ruleForm.imageTextUrl =  this.uploadedLinksText.map(file => file.name).join(',') 
            // }
            // }
           
        },
        handleUploadError() {
            this.$message({
                type: "error",
                message: "上传失败",
            });
            this.loading.close();
        },
        handleBeforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        }, 
        closeDialog() {
            this.resetForm()
            this.$emit('close');
        },
        handleClose(){
            this.resetForm()
            this.$emit('close');
        },   
        resetForm(){
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            } else {
                console.error('表单组件未找到');
            }
        },
        // 超出限制时的回调（Element UI内置）
        handleExceed() {
            this.$message.warning('最多只能上传9张图片');
        },
        // // 上传所有文件
        // async uploadAllFiles(file) {
        //     if (this.fileList.length === 0) {
        //         this.$message.warning('请先选择文件');
        //         return;
        //     }
        //     for (const file of this.fileList) {
        //         try {
        //         const base64Data = await this.fileToBase64(file.raw);
        //         await this.uploadSingleImage(base64Data, file.raw.name);
        //         } catch (error) {
        //         // 错误已在 uploadSingleFile 中处理，这里可以继续上传其他文件
        //         }
        //     }
        // },
        // // 将文件转换为 Base64
        // fileToBase64(file) {
        //     return new Promise((resolve, reject) => {
        //         const reader = new FileReader();
        //         reader.onload = () => resolve(reader.result);
        //         reader.onerror = error => reject(error);
        //         reader.readAsDataURL(file);
        //     });
        // },
        // // 上传单张Base64图片
        // uploadSingleImage(base64Data) {
        //     let params = {
        //         opcode: 1022,
        //         images: base64Data
        //     }
        //     this.$api._requestAPI(params).then(res => {
        //         if (res.IsSuccess) {
        //             console.log('上传成功:', res.Message);
        //             const imageUrl = res.Message;
        //             this.$message.success('上传图片成功')
        //             if (imageUrl) {
        //                 this.uploadedLinksMain.push(imageUrl); // 将链接添加到数组中
        //             }             
        //         } else {
        //             this.$message.error(res.Message)
        //         }
        //     }).catch(error => {
        //         console.log(error)
        //         // this.$message.error('上传图片失败,请重新上传!')           
        //     })     
        // },   
    }
}
</script>
<style lang='scss' scoped>
.image {
    position: relative;

    .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
    }

    &:hover .mask {
    opacity: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/product/components/addGoods.vue